export const SET_SUBSCRIPTION_VALUE_4_REGISTER =
  'SET_SUBSCRIPTION_VALUE_4_REGISTER/SALES-CHALLENGE';

export function setSubscriptionValue4Register(payload) {
  return {
    type: SET_SUBSCRIPTION_VALUE_4_REGISTER,
    payload,
  };
}
